import { whatsappAccountWsClient, whatsappChatWsClient } from "../request";
import {
  ChannelTypeEnum,
  ServiceType,
  WhatsAppContactType,
  WhatsAppMsgType,
} from "../types";
import { WHATSAPP_WS_REQUEST_TYPE } from "../handler/whatsapp/ws-types";

/**
 * 打开客户端（登录取二维码）
 */
const sendOpenClientCommand = (params: {
  team_id: string;
  user_id: string;
  service_type: ServiceType;
  client_id?: number;
  ip?: string;
  request_key?: string;
  /** 同步离线期间最新消息 */
  fetch_history_msg?: boolean;
}) => {
  const {
    team_id,
    fetch_history_msg,
    user_id,
    service_type,
    client_id,
    ip,
    request_key,
  } = params;
  return whatsappAccountWsClient.sendMessage({
    message_type: WHATSAPP_WS_REQUEST_TYPE.OPEN,
    channel_type: ChannelTypeEnum.WhatsApp,
    service_type,
    ip,
    client_id,
    user_id,
    data:
      fetch_history_msg !== void 0
        ? {
            teamId: team_id,
            fetchHistoryMsg: fetch_history_msg,
          }
        : { teamId: team_id },
    request_key,
  });
};

/**
 * 发送文本消息
 */
export type WhatsAppSendTextParams = {
  content: string;
  chat_id: string;
  to_id: string;
  chat_type: WhatsAppContactType;
  request_key: string;
};
const sendTextCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WhatsAppSendTextParams
) => {
  const request_key = data.request_key;
  const { chat_id, to_id, chat_type, content } = data;
  return whatsappChatWsClient.sendMessage({
    message_type: WHATSAPP_WS_REQUEST_TYPE.SEND_TEXT,
    channel_type: ChannelTypeEnum.WhatsApp,
    user_id: from_user_id,
    service_type,
    request_key,
    data: {
      user_id: from_user_id,
      chat_id,
      chat_type,
      to_id,
      msg_type: WhatsAppMsgType.TEXT_0,
      content,
    },
  });
};

/**
 * 发送图片消息
 */
export type WhatsAppSendImageParams = {
  path: string;
  file_name: string;
  chat_id: string;
  to_id: string;
  chat_type: WhatsAppContactType;
  request_key: string;
};
const sendImageCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WhatsAppSendImageParams
) => {
  const request_key = data.request_key;
  const { chat_id, to_id, chat_type, path, file_name } = data;
  return whatsappChatWsClient.sendMessage({
    message_type: WHATSAPP_WS_REQUEST_TYPE.SEND_IMAGE,
    channel_type: ChannelTypeEnum.WhatsApp,
    user_id: from_user_id,
    service_type,
    request_key,
    data: {
      user_id: from_user_id,
      chat_id,
      chat_type,
      to_id,
      msg_type: WhatsAppMsgType.QW_IMAGE,
      path,
      file_name,
    },
  });
};

/**
 * 发送文件消息
 */
export type WhatsAppSendFileParams = {
  path: string;
  file_name: string;
  chat_id: string;
  to_id: string;
  chat_type: WhatsAppContactType;
  request_key: string;
};
const sendFileCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WhatsAppSendFileParams
) => {
  const request_key = data.request_key;
  const { chat_id, to_id, chat_type, path, file_name } = data;
  return whatsappChatWsClient.sendMessage({
    message_type: WHATSAPP_WS_REQUEST_TYPE.SEND_FILE,
    channel_type: ChannelTypeEnum.WhatsApp,
    user_id: from_user_id,
    service_type,
    request_key,
    data: {
      user_id: from_user_id,
      chat_id,
      chat_type,
      to_id,
      msg_type: WhatsAppMsgType.QW_FILE,
      path,
      file_name,
    },
  });
};

const WhatsAppCommand = {
  sendOpenClientCommand,
  sendTextCommand,
  sendImageCommand,
  sendFileCommand,
};
export default WhatsAppCommand;
